// Schermata.tsx — schermate semplici a tutto schermo: avvio, manutenzione, aggiornamento, errore.
import type { ReactNode } from "react";
import { Faccina } from "../componenti/Faccina.tsx";
import type { IdTema } from "../temi/temi.ts";

export function Schermata({ tema, testo, azione }: { tema: IdTema; testo: string; azione?: ReactNode }) {
  return (
    <div className="pagina schermata-semplice" role="status" aria-live="polite">
      <Faccina tema={tema} dimensione={96} />
      <p className="schermata-testo">{testo}</p>
      {azione}
    </div>
  );
}
